export const filterArray = [
  {
    code: 'filter-date',
    desc: 'Filter by date ',
    type: 'date',
    options: {
      titleFrom: 'Date from',
      titleTo: 'Date to',
      default: false,
    },
  },
  {
    code: 'price',
    desc: 'Filter by price',
    type: 'number',
    options: {
      titleFrom: 'Price from',
      titleTo: 'Price to',
      min: 0,
      default: false,
    },
  },
  {
    code: 'organiser',
    desc: 'Filter by organiser',
    type: 'checkbox',
    options: [],
  },
  {
    code: 'location',
    desc: 'Filter by location',
    type: 'checkbox',
    options: [
      {
        code: 'online',
        desc: 'Online',
        default: false,
      },
      {
        code: 'inPerson',
        desc: 'In-person',
        default: false,
      },
    ],
  },
  {
    code: 'availability',
    desc: 'Filter by ticket availability',
    type: 'checkbox',
    options: [
      {
        code: 'available',
        desc: 'Tickets available',
        default: false,
      },
    ],
  },
];

export enum Options {
  Date = 0,
  Price,
  Organisers,
  Location,
  Availability,
}
